module.exports = __webpack_public_path__ + "static/media/flag-rectangle-mi.cc814a57.png";